import * as Colours from "../../../../globalStyles/administratorColors";

export const body = {
    paddingRight: "30px",
    paddingTop: "20px"
};

export const columRight = {
    textAlign: "right"
};

export const counter = {
    textAlign: "right",
    color: "red"
};

export const cardStyle = {
    backgroundColor: Colours.primary,
    color: "white",
    cursor: "pointer"
};

export const headingContainer = {
    display: "flex",
    alignItems: "center",
    columnGap: "10px"
};

export const editNotice = {
    fontWeight: "bold"
};

export const hidden = {
    visibility: "hidden"
};

export const headingTextContainer = {
    width: "100%"
};
